<template>
  <div :class="{ 'form-control': true, 'is-select': true }">
    <v-select
      :options="orders"
      v-model="order_id"
      :reduce="order => order.id"
      :filterBy="filterByForOrders"
      :placeholder="$t('order.selectOrder')"
      :disabled="disabled"
      label="order_name"
      @search="debouncedFetchOrders">
      <template slot="no-options">
        <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
        <template v-if="emptyResults">{{ $t('order.noOrderMatchingPhraseFound') }}&hellip;</template>
      </template>
      <template
        slot="option"
        slot-scope="option">
        <div class="d-center">
          {{ option.order_name }}
        </div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option">
        <div class="selected d-center">
          {{ option.order_name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'select-order',
  props: {
    customerID: {
      default: null,
      type: [String, Number]
    },
    disabled: {
      default: false,
      type: Boolean
    },
    orderID: {
      default: null,
      type: [String, Number]
    }
  },
  watch: {
    order_id (newValue) {
      this.$bus.$emit('ui-select-order-updated', newValue);

      if (newValue === null && this.customerID) {
        this.loadOrdersForCustomer();
      }
    }
  },
  data () {
    return {
      order_id: null,
      orders: [],
      emptyResults: false,
      loadError: false
    };
  },
  mounted () {
    this.order_id = this.orderID;

    if (this.order_id) {
      this.prefetchOrder(this.order_id);
    } else {
      this.order_id = null;
      this.loadOrdersForCustomer();
    }

    this.$bus.$on('ui-select-order-reset', this.resetValue);
  },
  methods: {
    filterByForOrders (option, label, search) {
      return (option.id + ' ' + option.order_name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    prefetchOrder (orderID) {
      if (!orderID) {
        return;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/item/' + parseInt(orderID, 10),
        outputKey: 'orders',
        errorKey: 'loadError',
        method: 'get',
        params: {
          with: []
        },
        wrapResponseIntoArray: true,
        successAction: (response) => {
          this.order_id = parseInt(orderID, 10);

          if (!response[0]) {
            this.loadError = true;
            this.orders = [{
              id: this.order_id,
              order_name: this.$t('ui.loadError') + ' (#' + this.order_id + ')'
            }];
          }
        }
      });
    },
    fetchOrders (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/orders/items';
      let responseAsArray = false;
      let paramsData = {
        where: {}
      };

      if (searchPhrase) {
        paramsData.where.order_name = searchPhrase;
      }

      if (this.customerID) {
        paramsData.where.customer_id = this.customerID;
      }

      if (this.order_id !== 0 && this.order_id !== null && searchPhrase === '') {
        endpointUrl = '/orders/item/' + parseInt(this.order_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        method: 'get',
        outputKey: 'orders',
        errorKey: 'loadError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          } else {
            this.emptyResults = false;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchOrders: debounce(function (searchPhrase, loadingCallback) {
      this.fetchOrders(searchPhrase, loadingCallback);
    }, 500),
    resetValue () {
      this.order_id = null;
    },
    loadOrders () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/items',
        outputKey: 'orders',
        errorKey: 'loadError',
        method: 'get',
        params: {
          where: {}
        },
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          } else {
            this.emptyResults = false;
          }
        }
      });
    },
    loadOrdersForCustomer () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/items',
        outputKey: 'orders',
        errorKey: 'loadError',
        method: 'get',
        params: {
          where: {
            customer_id: this.customerID
          }
        },
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          } else {
            this.emptyResults = false;
          }
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('ui-select-order-reset', this.resetValue);
  }
};
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
